import store from "@/store";
import { storeActions } from "@/constants/store-actions";
import { routeData } from "@/router/constants/routes";
import { saveSession } from "@/helpers/heritage-integration/order-helper";

export async function duplicateCheckBeforeEnter(to, from) {
    const morePolicyQuestions = store.getters.order?.policy?.morePolicyQuestions;
    const hasMorePolicyQuestions = Object.values(morePolicyQuestions ?? {}).some(Boolean);

    if (store.getters.order?.payment?.insuranceCoverage.isVerified || hasMorePolicyQuestions) {
        return {
            name: routeData.COVERAGE_STATEMENT.name,
        };
    }

    const duplicateOrders = await store.dispatch(storeActions.GET_DUPLICATE_REFERRALS, {
        pageNameToLog: to.name,
    });

    if (duplicateOrders?.length === 0 || store.getters.order?.isLoadedFromDuplicateCheck) {
        if (store.getters.order?.referralNumber?.length != 6) {
            await store.dispatch(storeActions.SAVE_SUBMIT_TO_MAINFRAME, true);
        }

        await saveSession({
            pageNameToLog: routeData.POLICY_VEHICLE.name,
            shouldAwaitSaveSessionQueue: true,
        });

        if (hasMorePolicyQuestions) {
            return {
                name: routeData.COVERAGE_STATEMENT.name,
            };
        }

        return {
            name: routeData.POLICY_VEHICLE.name,
        };
    }
}
